import React from 'react';
import { Link, Tooltip, Typography } from '@material-ui/core';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';

import MUIDataTable from 'mui-datatables';
import { TEXT_LABELS } from '../../common/configTable';
import ThemeContainer from '../../common/ThemeProvider';

const QueryTable = ({ data: reports }) => {
  const columns = [
    {
      name: 'count',
      label: 'ID',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => tableMeta.rowIndex + 1,
      },
    },
    {
      name: 'id',
      label: 'id',
      options: {
        filter: false,
        display: 'excluded',
      },
    },
    {
      name: 'url',
      label: 'url',
      options: {
        filter: false,
        display: 'excluded',
      },
    },
    {
      name: 'description',
      label: 'Descripción',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'user.fullname',
      label: 'Investigador',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'project.name',
      label: 'Proyecto',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => {
          return <span>{value.substring(0, 20)}</span>;
        },
      },
    },
    {
      name: 'type',
      label: 'Tipo',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'created_at',
      label: 'Fecha elaboración',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: '',
      label: 'Acciones',
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          return (
            <Tooltip title='Ver PDF'>
              <Link
                style={{ textDecoration: 'none', cursor: 'pointer' }}
                to='#'
                onClick={(e) => handleOpenPDF(e, `${tableMeta.rowData[2]}`)}
              >
                <PictureAsPdfIcon color={'primary'} />
              </Link>
            </Tooltip>
          );
        },
      },
    },
  ];
  const options = {
    enableNestedDataAccess: [],
    sort: true,
    searchPlaceholder: 'Buscar',
    filterType: 'dropdown',
    responsive: 'scroll',
    rowsPerPage: 20,
    rowsPerPageOptions: [5, 10, 20],
    selectableRows: 'none',
    textLabels: TEXT_LABELS,
  };

  const handleOpenPDF = (e, url) => {
    e.preventDefault();
    if (url !== null) window.open(url);
  };
  return (
    <ThemeContainer>
      <MUIDataTable
        title={<Typography variant='h6'>Lista de informes</Typography>}
        data={reports}
        columns={columns}
        options={options}
        responsive={'scrollFullHeight'}
      />
    </ThemeContainer>
  );
};

export default QueryTable;
